/**
 * HR Dashboard Constants
 * Centralized constants for HR Hank dashboard
 */

// Onboarding status options
export const ONBOARDING_STATUSES = {
  PENDING: 'pending_hr_entry',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  DELAYED: 'delayed',
  AT_RISK: 'at_risk'
};

// Aging buckets for tracking days since offer acceptance
export const AGING_BUCKETS = [
  { key: '0-7', label: '0-7 days', min: 0, max: 7, color: 'bg-green-100 text-green-800' },
  { key: '8-14', label: '8-14 days', min: 8, max: 14, color: 'bg-yellow-100 text-yellow-800' },
  { key: '15-30', label: '15-30 days', min: 15, max: 30, color: 'bg-orange-100 text-orange-800' },
  { key: '30+', label: '30+ days', min: 31, max: 999, color: 'bg-red-100 text-red-800' }
];

// Status color mapping
export const STATUS_COLORS = {
  [ONBOARDING_STATUSES.PENDING]: 'bg-blue-100 text-blue-800',
  [ONBOARDING_STATUSES.IN_PROGRESS]: 'bg-yellow-100 text-yellow-800',
  [ONBOARDING_STATUSES.COMPLETED]: 'bg-green-100 text-green-800',
  [ONBOARDING_STATUSES.DELAYED]: 'bg-red-100 text-red-800',
  [ONBOARDING_STATUSES.AT_RISK]: 'bg-orange-100 text-orange-800'
};

// Status label mapping
export const STATUS_LABELS = {
  [ONBOARDING_STATUSES.PENDING]: 'Pending HR Entry',
  [ONBOARDING_STATUSES.IN_PROGRESS]: 'In Progress',
  [ONBOARDING_STATUSES.COMPLETED]: 'Completed',
  [ONBOARDING_STATUSES.DELAYED]: 'Delayed',
  [ONBOARDING_STATUSES.AT_RISK]: 'At Risk'
};

// HR-relevant submission statuses
export const HR_RELEVANT_STATUSES = [
  'Offer Extended',
  'Offer Accepted',
  'Onboarding Initiated',
  'Onboarding',
  'Onboarded'
];

// API timeout configurations
export const API_TIMEOUTS = {
  SUBMISSIONS: 10000, // 10s
  CANDIDATES: 30000,  // 30s
  JOBS: 30000,        // 30s
  CLIENTS: 10000,     // 10s
  RECRUITERS: 10000   // 10s
};

// Data fetch limits
export const DATA_LIMITS = {
  CANDIDATES: 1000,
  JOBS: 5000
};
